import { Switch, styled } from "@mui/material";
import { TextareaAutosize } from '@mui/base/TextareaAutosize';

const blue = {
    100: '#DAECFF',
    200: '#b6daff',
    400: '#3399FF',
    500: '#007FFF',
    600: '#0072E5',
    900: '#003A75',
};

const grey = {
    50: '#f6f8fa',
    100: '#eaeef2',
    200: '#d0d7de',
    300: '#afb8c1',
    400: '#8c959f',
    500: '#6e7781',
    600: '#57606a',
    700: '#424a53',
    800: '#32383f',
    900: '#24292f',
};

export const StyledTextarea = styled(TextareaAutosize)(
    ({ theme }) => ` width: 100%; font-family: IBM Plex Sans, sans-serif; font-size: 0.875rem; font-weight: 400; line-height: 1.5; padding: 12px; border-radius: 6px; 
  color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]}; background: #FFF; 
  border: 1px solid #E5E7EA; box-shadow: 0px 2px 2px ${theme.palette.mode === 'dark' ? grey[900] : grey[50]};
  &:hover {
  border-color: ${blue[400]};
  }
  &:focus {
  border-color: ${blue[400]};
  box-shadow: 0 0 0 3px ${theme.palette.mode === 'dark' ? blue[500] : blue[200]};
  }
  // firefox
  &:focus-visible {
  outline: 0;
  }
  `,
);
export const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 40,
    height: 24,
    padding: 0,
    display: 'flex',
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 2,
        transitionDuration: '200ms',
        '&.Mui-checked': {
            transform: 'translateX(16px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: '#4F8506',
                borderColor: '#4F8506',
            },
            '& .MuiSwitch-thumb': {
                backgroundColor: '#FFFFFF',
            },
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: '#FFFFFF',
            border: '6px solid #FFFFFF',
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
            color: theme.palette.mode === 'light' ? grey[100] : grey[600],
        },
        '&.Mui-disabled + .MuiSwitch-track': {
            opacity: theme.palette.mode === 'light' ? 0.5 : 0.3,
        },
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 20,
        height: 20,
        borderRadius: 10,
        backgroundColor: '#FFFFFF',
        boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.30), 0px 1px 2px rgba(0, 0, 0, 0.15)',
    },
    '& .MuiSwitch-track': {
        borderRadius: 12,
        opacity: 1,
        backgroundColor: '#D9D9D9',
        border: '2px solid #D9D9D9',
        boxSizing: 'border-box',
        transition: theme.transitions.create(['background-color', 'border-color'], {
            duration: 200,
        }),
    },
}));

